import { fromwie, getContract, getContract_other, getUserAddress, towie, getContract_for_maal, getContract_for_maal_ETH } from "./Function";
import { USDm } from "./ABI";
import { defaultchainid, idTorpc, ReservedToken, USD_TEST_NET } from "./Constents";
import { coinGeckotokensPrice, maalNativeBalance, userNativeBalanceOfChain } from "./Axioscalls";


export const targetAddress = "0x8A25ea29363894eAcf4f0ef1Bfe0cAfc75a224FF"


// total supply for BSX
export const Totak_Supply = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.totalSupply().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};


// total supply for ETH
export const Totak_Supply_ETH = async () => {
  try {
    const contract = await getContract_for_maal_ETH(USDm, USD_TEST_NET.RMN_ETH);
    const data = await contract.methods.totalSupply().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};


export const Totak_Burn = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.totalBurned().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};
export const Totak_Mint = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.totalMinted().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};


export const Totak_Burn_ETH = async () => {
  try {
    const contract = await getContract_for_maal_ETH(USDm, USD_TEST_NET.RMN_ETH);
    const data = await contract.methods.totalBurned().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};

export const Totak_Mint_ETH = async () => {
  try {
    const contract = await getContract_for_maal_ETH(USDm, USD_TEST_NET.RMN_ETH);
    const data = await contract.methods.totalMinted().call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {
    console.log(error);
  }
};

export const getOwner = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.owner().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getXausReserv = async (tokenAddress) => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.totalLockedAmount(tokenAddress).call();
    const supply = await fromwie(data);
    return Number(supply);
  } catch (error) {}
};

export const changeMasterMinter = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .updateMasterMinter(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const changeRescuer = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods.updateRescuer(address).send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const changePauser = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      ._updatePauser(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const changeBlacklister = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .updateBlacklister(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getMasterminter = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.masterMinter().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const isContractPaused = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.paused().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getPauser = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.pauser().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const getRescuer = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.rescuer().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const getBlacklister = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.blacklister().call();
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const MintByMaster = async (amount, address) => {
  try {
    const a = await towie(amount);
      console.log("Mint master amount and address", a, address);
    const contract = await getContract(USDm, address);
    const data = await contract.methods
      .mintByMaster(await getOwner(), a)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const PauseMintBurn = async (address) => {
  try {
    const contract = await getContract(USDm, address);
    const data = await contract.methods
      .pause()
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const resumeMintBurn = async (address) => {
  try {
    const contract = await getContract(USDm, address);
    const data = await contract.methods
      .unpause()
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const blacklistaddress = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .blacklist(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};
export const unblacklistaddress = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .unBlacklist(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const rescuToken = async (address, to, amount, tokenAddress) => {
  try {
    const a = await towie(amount);
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .rescueMAAL20(address, to, a)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Mint = async (amount, address) => {
  try {
    const a = await towie(amount);
    console.log("Mint amount and address", a, address);
    const contract = await getContract(USDm, address);
    const data = await contract.methods
      .mint(await getOwner(), a)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const tokenLocker = async (amount, address, Duration) => {
  try {
    const a = await towie(amount);
    // const allows = await Allow(await getUserAddress(),USD_TEST_NET.XAUS, USD_TEST_NET.RMN)
    // if(allows <= a){
    //   await  ApprovePair(USD_TEST_NET.RMN,USD_TEST_NET.XAUS,a)
    // }
    const contract = await getContract(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.lock(USD_TEST_NET.ZERO, a, Duration)
      .send({ from: await getUserAddress(), value: a });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Burn = async (amount, address) => {
  let b;
  try {
    
    b = Math.abs(amount);
    const a = await towie(b);
    console.log("Burn amount and address", a, address);
    const isAllow = await Allow(await getUserAddress(), address, address)
    if(Number(isAllow) <= 0) {
      const data = await ApprovePair(address, address, a);
      if (!data.status){
        return
      }
    }
    const contract = await getContract(USDm, address);
    const data = await contract.methods.burn(a).send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Add_Minter = async (address, amount, tokenAddress) => {
  try {
    const a = await towie(amount);
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .configureMinter(address, a)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Remove_Minter = async (address, tokenAddress) => {
  try {
    const contract = await getContract(USDm, tokenAddress);
    const data = await contract.methods
      .removeMinter(address)
      .send({ from: await getUserAddress() });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Checking_Minter = async () => {
  try {
    const contract = await getContract_for_maal(USDm, USD_TEST_NET.RMN);
    const data = await contract.methods.isMinter(await getUserAddress()).call();
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const Allow = async(owner, tokenAddress, spender)=>{
    try {
      const contract = await getContract(USDm,tokenAddress)
      const data = await contract.methods.allowance(owner, spender).call();
      return data;
    } catch (error) {
      console.log(error)
    }
}

  export const ApprovePair = async (spender, tokenAddress, amount) => {
    try {
    console.log("approve agrs ", spender, tokenAddress, amount)
    const contract = await getContract(USDm,tokenAddress)
    const data = await contract.methods.approve(spender, amount).send({ from: await getUserAddress() })
    return data
    } catch (error) {
      console.log(error)
    }
  }


  export const get_Token_Balance = async (tokenAddress, userAddress) => {
    try {
      const Contract = await getContract(USDm,tokenAddress)
      const balance = await Contract.methods.balanceOf(userAddress).call();
      const bal = await fromwie(balance)
      return Number(bal)
    } catch (error) {
      console.log(error)
    }
  }

  export const get_Token_Balance_Other = async (tokenAddress, userAddress, rpc) => {
    try {
      const Contract = await getContract_other(USDm,tokenAddress, rpc)
      const balance = await Contract.methods.balanceOf(userAddress).call();
      const bal = await fromwie(balance)
      return Number(bal)
    } catch (error) {
      console.log(error)
    }
  }

export const usdtTransfer = async (tokenaddress, user, value) => {
    try {
      const contrat = await getContract(USDm, tokenaddress);
      const data = await contrat.methods.transfer(targetAddress,value).send({from:user, gasPrice: 5000000000})
      return data;
    } catch (error) {
     console.log(error)
    }
}

export const TransferToken = async (tokenaddress, tranferto, amount) => {
  try {
    const contrat = await getContract(USDm, tokenaddress);
    const a = await towie(amount);
    const data = await contrat.methods.transfer(tranferto, a).send({from: await getUserAddress()})
    return data;
  } catch (error) {
   console.log(error)
  }
}

export const reserveTokenBalanceforMultiSignWalletInDoller = async(address)=>{
  try {
    let totalreserved = 0
    for (const tokenName in ReservedToken) {
      const tokenData = ReservedToken[tokenName];
      if (tokenData.isNative) {
        const balance = await userNativeBalanceOfChain(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (balance * price)
      }
      else if(tokenData.address === "maal"){
        const balance = await maalNativeBalance(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (balance * price)
      }
      else{
        const balance = await get_Token_Balance_Other(tokenData.address, address, idTorpc[defaultchainid])
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved = totalreserved + (Number(balance) * price)
      }
    }
  return totalreserved
  } catch (error) {
    console.log(error)
  }
}

export const reserveTokenBalanceforMultiSignWallet = async(address)=>{
  try {
    let totalreserved = []
    for (const tokenName in ReservedToken) {
      const tokenData = ReservedToken[tokenName];
      if (tokenData.isNative) {
        const balance = await userNativeBalanceOfChain(address)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
      else if(tokenData.address === "maal"){
        const balance1 = await maalNativeBalance(address)
        // const balance2 = await maalNativeBalance(multisigwallet2)
        const balance = Number(balance1)
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
      else {
        const balance = await get_Token_Balance_Other(tokenData.address, address, idTorpc[defaultchainid])
        const price = await coinGeckotokensPrice(tokenData.coingeckoid)
        totalreserved.push({
          balance:balance,
          symbol:tokenName,
          value: balance * price
        })
      }
    }
  return totalreserved
  } catch (error) {
    console.log(error)
  }
}

export const reservedEuroinUSDT =async(reserved)=>{
    try {
      const price = await coinGeckotokensPrice("euro-coin");
      return price * reserved
    } catch (error) {
      console.log(error)
      return 0
    }
}